import { render, staticRenderFns } from "./UnionSync.vue?vue&type=template&id=70dcdd03&scoped=true"
import script from "./UnionSync.vue?vue&type=script&lang=js"
export * from "./UnionSync.vue?vue&type=script&lang=js"
import style0 from "./UnionSync.vue?vue&type=style&index=0&id=70dcdd03&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dcdd03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70dcdd03')) {
      api.createRecord('70dcdd03', component.options)
    } else {
      api.reload('70dcdd03', component.options)
    }
    module.hot.accept("./UnionSync.vue?vue&type=template&id=70dcdd03&scoped=true", function () {
      api.rerender('70dcdd03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/userSetting/union/components/UnionSync.vue"
export default component.exports